import { render, staticRenderFns } from "./formulator-slide-and-select.vue?vue&type=template&id=156d52c5&"
import script from "./formulator-slide-and-select.vue?vue&type=script&lang=js&"
export * from "./formulator-slide-and-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports